import { faqs } from '@/mocks/articles';

export default function FAQ() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-500/40 text-accent-400 text-xs font-medium mb-4 whitespace-nowrap">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-3">
            关于911爆料网
          </h2>
          <p className="text-sm md:text-base text-foreground-300">
            你可能想了解的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-200 border border-background-300 rounded-xl overflow-hidden">
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h4 className="text-sm md:text-base font-heading font-bold text-foreground-50 pr-4">
                  {faq.question}
                </h4>
                <span className="w-6 h-6 rounded-full bg-background-300 flex items-center justify-center flex-shrink-0 group-open:rotate-45 transition-transform duration-300">
                  <i className="ri-add-line text-foreground-300 text-sm"></i>
                </span>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-sm text-foreground-300 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}